import {
  POPUP_SHOW,
  POPUP_HIDE,
  POPUP_DELETE_ALL, POPUP_DELETE, POPUP_SHOW_ALL, POPUP_SHOW_HIDDEN
} from 'actions/popup';

const initialState = {
  stack: []
};

const popup = (state = initialState, action) => {
  switch (action.type) {
    case POPUP_SHOW: {
      let next = {...state};
      next.stack = (state.stack || initialState.stack).slice();
      next.stack.push({...action.payload});
      return next;
    }

    case POPUP_HIDE: {
      const {key} = action.payload;

      let next = {...state};
      next.stack = (state.stack || initialState.stack);

      if (next.stack.length > 0 && !key) {
        const showPopupStack = next.stack.filter(popup => !popup.softDel);
        if (showPopupStack.length > 0)
          showPopupStack[showPopupStack.length-1].softDel = true;
      } else {
        if (next.stack.length > 0 && key) {
          const pp = next.stack.find(popup => popup.key === key);
          pp.softDel = true;
        }
      }

      return {...next};
    }

    case POPUP_DELETE: {
      const {key} = action.payload;

      let next = {...state};
      next.stack = (state.stack || initialState.stack).filter(item => item.key !== key);

      if (next.stack.length > 0 && !key)
        next.stack.pop();

      return {...next};
    }

    case POPUP_DELETE_ALL: {
      return {...initialState};
    }

    case POPUP_SHOW_HIDDEN: {
      const {key} = action.payload;

      let next = {...state};
      next.stack = (state.stack || initialState.stack);

      if (next.stack.length > 0) {
        next.stack
          .filter(popup => popup.softDel && (key === popup.key || !key))
          .forEach(popup => popup.softDel = false);
      }

      return {...next};
    }
    default: {
      return state;
    }
  }
};

export default popup;


// WEBPACK FOOTER //
// ./src/reducers/popup.js